module.exports = __webpack_public_path__ + "img/app_icon_42.05478572.png";